import { Info24px } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Text, Flex } from "@similarweb/ui-components/foundations";

import {
    NoTouchPurchaseSummaryModalDetailsInfo,
    StyledLink,
} from "app/components/no-touch-purchase-modal/summary-modal/details/StyledNoTouchPurchaseSummaryModalDetails";
import type { INoTouchAddon } from "app/components/no-touch-purchase-modal/summary-modal/useNoTouchPurchaseSummaryModal";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";
import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

interface IFooterProps {
    isLoading: boolean;
    selectedAddon?: INoTouchAddon;
    onPurchaseClick: () => void;
}

export const Footer = ({ isLoading, selectedAddon, onPurchaseClick }: IFooterProps) => {
    return (
        <Flex
            flexDirection="column"
            gap="24px"
        >
            <Button
                type="primary"
                isDisabled={!selectedAddon || isLoading}
                onClick={onPurchaseClick}
                width={"100%"}
            >
                {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.buttonText)}
            </Button>

            <NoTouchPurchaseSummaryModalDetailsInfo>
                <Flex>
                    <Info24px size="sm" />
                </Flex>
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon[400]}
                >
                    {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.info)}
                </Text>
            </NoTouchPurchaseSummaryModalDetailsInfo>

            <Flex
                flexDirection="column"
                gap="8px"
                width={"100%"}
            >
                <Flex
                    gap="10px"
                    justifyContent="center"
                    alignItems="center"
                >
                    <img src={AssetsService.assetUrl("/images/no-touch-purchase/security-img.svg")} />
                    <Text fontVariant="body2">
                        {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.safePayment)}
                    </Text>
                </Flex>
                <Text
                    fontVariant="caption"
                    textAlign="center"
                >
                    {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.youAccept)}{" "}
                    <StyledLink
                        label={translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.tos)}
                        url="https://www.similarweb.com/corp/legal/terms/"
                    />
                </Text>
            </Flex>
        </Flex>
    );
};
